// Unpublished Work © 2022-2024 Deere & Company.

export const ONE_HUNDRED_PERCENT = 100;
export const MAX_NUMERIC_VALUE = 2000000000000;
export const MIN_NUMERIC_VALUE = 0;
export const NOT_AVAILABLE = '---';
